<div class="container">
    <h3 mat-dialog-title class="label">Are you sure to delete ?</h3>
    <div mat-dialog-content>
     <div class="label"> First Name:  {{data.firstName}} </div> 
      <p></p>
      <div class="label"> Last Name: {{data.lastName}} </div> 
      <p></p>
    </div>
    <div mat-dialog-actions>
      <button mat-button [mat-dialog-close]="1" (click)="confirmDelete()">Delete</button>
      <button mat-button (click)="onNoClick()" tabindex="-1">Cancel</button>
    </div>
  </div>
  